import instance from '../utils/axios';

class DealerOrderService {

    async getBomList(pageIndex, keyword, startTime, endTime) {
        // eslint-disable-next-line no-debugger
        return await instance.post('/erp/radOrder/getBomList', {
            startTime: startTime,
            endTime: endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'dealerId.rad_dealer,creatorId.base_stafft,caliber.dict_rad_caliber,color.dict_rad_color' +
                ',waterFlow.dict_rad_flowin_method,custom_dropdown_2.dict_order_free_bool'
        });
    }

    async getBomDetailList(pageIndex,bomId, keyword, startTime, endTime) {
        // eslint-disable-next-line no-debugger
        return await instance.post('/erp/radOrder/getBomDetailList', {
            bomId: bomId,
            startTime: startTime,
            endTime: endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_name: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'asc',
            dictionaryNames: 'type.rad_bom_detail_type,creatorId.base_staff,custom_dropdown_07.dict_sku_production_mode,custom_text_07.dict_producing_outpu'
        });
    }

}
export default new DealerOrderService();